module.exports = __webpack_public_path__ + "assets/img/dianhua2.28d79bbb.png";